module.exports = __webpack_public_path__ + "img/06.e3817dbf.jpg";